/** Role of a member in a tenant. */
export enum MemberRole {
  OWNER = 'OWNER',
  ADMINISTRATOR = 'ADMINISTRATOR',
  NORMAL = 'NORMAL',
}
